import React from "react";
import ClientDashboardChart from "./ClientDashboardChart";
import { Link } from "react-router-dom";
import { PiGreaterThanBold } from "react-icons/pi";
import { useSelector, useDispatch } from "react-redux";
import { UPDATE_USER_DATA } from "../redux/features/user/userSlice";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { handleApi } from "../utils/authentication";
import { useNavigate } from "react-router-dom";
import {
  clientHasAccess,
  clientIsExpired,
  fetchAndApplySubscriptionAccess,
  getSubscriptionLockedFallbackPath,
} from "../utils/subscriptionAccess";

const UniversityCard = ({
  university_logo,
  client_id,
  university_name,
  total_spend_value,
  total_spend_percentage,
  impressions_value,
  impressions_percentage,
  leads_value,
  leads_percentage,
  total_members = null,
  subscription_start_date = null,
  subscription_end_date = null,
  is_subscription_expired = 0,
  is_blocked = 0,
  client_data = {},
}) => {
  const user = useSelector((state) => state?.user);
  const location = useLocation();
  let btn_active = location.pathname.startsWith("/client/dashboards");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cardClient = {
    ...client_data,
    subscription_end_date,
    is_subscription_expired,
    can_access: client_data?.can_access,
    subscription_access: client_data?.subscription_access,
  };

  const isExpired = clientIsExpired(cardClient);
  const hasAccess = clientHasAccess(cardClient);
  const isDisabled = isExpired || is_blocked;

  const handleSelectClient = async () => {
    try {
      if (!hasAccess && user?.is_client) {
        toast.error(
          user?.role_id < 3
            ? "Your trial or subscription has expired. Please subscribe to continue."
            : "Your organization's subscription has expired. Please contact your administrator.",
        );
        navigate(getSubscriptionLockedFallbackPath(user));
      } else if (is_blocked) {
        toast.error(
          "This U-Intelligence account has been blocked. Please contact the Admin for assistance.",
        );
      } else {
        let formData = new FormData();
        formData.append("user_id", user?.user_id);
        formData.append("client_id", client_id);
        let result = await handleApi("generate_new_token", "POST", {}, formData);
        if (result?.success) {
          dispatch(
            UPDATE_USER_DATA({
              client_id: client_id,
              client_name: university_name,
              total_members: total_members,
              program_id: null,
              program_name: "All",
              is_agency: client_data?.is_agency,
              token: result?.data?.user_info?.token,
              role_id: result?.data?.user_info?.role_id,
              role_name: result?.data?.user_info?.role_name,
              is_agency: result?.data?.user_info?.is_agency,
            }),
          );
          await fetchAndApplySubscriptionAccess(client_id);
          navigate("dashboards/home");
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className={`custom-card  ${isDisabled && "disable_card"}`}>
        <div className="custom-card-header py-3">
          <div className="d-flex justify-content-between">
            <h5 className="card-title">{university_name}</h5>
            <div>
              {is_subscription_expired || isExpired ? (
                <div className="d-flex flex-column align-items-end gap-1 subscription_error_div">
                  <div className="subscription_expired_badge d-block">
                    <p className=" mb-0">Subscription Expired</p>
                  </div>
                  <span className="mb-2">
                    Your trial or subscription has expired. Subscribe to
                    continue using this account.
                  </span>
                </div>
              ) : (
                <></>
              )}
              {is_blocked ? (
                <div className="d-flex flex-column align-items-end subscription_error_div">
                  <div className="subscription_expired_badge d-block">
                    <p className=" mb-0">Blocked</p>
                  </div>
                  <span className="mb-2">
                    This U-Intelligence account has been blocked. Please contact
                    the Admin for assistance.
                  </span>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="custom-card-body">
            <div className="row">
              <div className="col-md-4 col-sm-3 ">
                <img
                  src={university_logo}
                  className="img-fluid"
                  style={{ width: "auto", height: "64px" }}
                  alt=""
                  srcSet=""
                />
              </div>
              <div className="col-md-8 pl-0 col-sm-9 position-relative">
                {user?.is_client && <ClientDashboardChart />}
              </div>
            </div>
            <div className="row  mt-3">
              <div className="col-md-4 card_table col-sm-6 ">
                <p className=" mb-0">TOTAL SPEND</p>
                <div className="d-flex gap-2 align-items-center">
                  <p className="mb-0">{total_spend_value}</p>
                </div>
              </div>
              <div className="col-md-4 card_table col-sm-6 ">
                <p className=" mb-0">IMPRESSIONS:</p>
                <div className="d-flex gap-2 align-items-center">
                  <p className="mb-0">{impressions_value}</p>
                </div>
              </div>
              <div className="col-md-4 card_table col-sm-6 ">
                <p className=" mb-0">LEDS</p>
                <div className="d-flex gap-2 align-items-center">
                  <p className="mb-0">{leads_value}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {user?.is_client ? (
          <div className="d-flex justify-content-end  custom-card-footer py-3">
            {isDisabled ? (
              <></>
            ) : (
              !btn_active && (
                <span
                  className="btn btn-md rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center "
                  onClick={handleSelectClient}
                >
                  Select Client <PiGreaterThanBold />{" "}
                </span>
              )
            )}
          </div>
        ) : (
          <div className="d-flex justify-content-end ">
            {!btn_active && (
              <Link
                to={`clients/${client_id}`}
                className="btn btn-md rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center "
                onClick={handleSelectClient}
              >
                Select Client <PiGreaterThanBold />{" "}
              </Link>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default UniversityCard;
